import { render, staticRenderFns } from "./OneTimeMenuDelete.vue?vue&type=template&id=2e2051a6&scoped=true"
import script from "./OneTimeMenuDelete.vue?vue&type=script&lang=js"
export * from "./OneTimeMenuDelete.vue?vue&type=script&lang=js"
import style0 from "./OneTimeMenuDelete.vue?vue&type=style&index=0&id=2e2051a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2051a6",
  null
  
)

export default component.exports